import { render, staticRenderFns } from "./MultipleSuppliersSelect.vue?vue&type=template&id=5e773f8e&"
import script from "./MultipleSuppliersSelect.vue?vue&type=script&lang=js&"
export * from "./MultipleSuppliersSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports